module.exports = __webpack_public_path__ + "img/reserved-seating-pricing.4494deb6.jpg";